export const setSubmitIds = (state, submitIds = []) => {
  return { submitIds };
};
